import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import { computed, defineComponent, onMounted, ref, toRefs, watch } from "@vue/composition-api";
import vSelectField from "@Shared/components/form-elements/fields/v-select-field.vue";
import { useApplicationStoreGetters, useApplicationStoreActions } from "@Broker/@Modules/clients/applications/application/store/application-helpers";
import * as ApplicationGetters from "@Broker/@Modules/clients/applications/application/store/application-getters";
import * as ApplicationsActions from "@Broker/@Modules/clients/applications/application/store/application-actions";
import { useI18n } from "vue-i18n-composable";
import ReportHistoryTableRowLoader from "@Broker/@Modules/marketing/components/lists/list-details-loader.vue";
import { APPLICATION_FIELD_OPTIONS } from "@Shared/@Utils/application-defaults-utils/global-field-options";
import MaterialInput from "@Shared/components/inputs/material-input.vue";
import { showToast } from "@Shared/@Utils/constants";
import FinancialTools from "../pages-components/application/financial-tools.vue";
import { formatDateHour } from "@Shared/@Utils/helpers/dates";
import * as AccountGetters from "@Broker/@Modules/main/store/account/account-getters";
import { useAccountStoreGetters } from "@Broker/@Modules/main/store/account/account-helpers";
import { isEmpty } from "lodash";
export default defineComponent({
  name: "Services",
  components: {
    vSelectField,
    SimpleButton,
    ReportHistoryTableRowLoader,
    MaterialInput,
    FinancialTools
  },
  props: {
    clientUsername: {
      type: String,
      default: ""
    }
  },
  setup(props) {
    const {
      GET_REFERRAL_API_PARTNERS
    } = useAccountStoreGetters([AccountGetters.GET_REFERRAL_API_PARTNERS]);
    const hasReferralPartners = !isEmpty(GET_REFERRAL_API_PARTNERS.value);
    const {
      CURRENT_APPLICATION,
      CURRENT_APPLICATION_HAS_REQUESTED_MORTGAGES
    } = useApplicationStoreGetters([ApplicationGetters.CURRENT_APPLICATION, ApplicationGetters.CURRENT_APPLICATION_HAS_REQUESTED_MORTGAGES]);
    if (!hasReferralPartners) return {
      CURRENT_APPLICATION_HAS_REQUESTED_MORTGAGES,
      hasReferralPartners
    };
    const loadingSubmissions = ref(true);
    const applicantsChecked = ref([{
      index: 0,
      isChecked: true
    }]);
    const {
      t,
      tc
    } = useI18n();
    const consentChecked = ref(false);
    const {
      clientUsername
    } = toRefs(props);
    const {
      INSURANCE_SUBMISSIONS_HISTORY,
      GET_INSURANCE_PROVIDERS
    } = useApplicationStoreGetters([ApplicationGetters.INSURANCE_SUBMISSIONS_HISTORY, ApplicationGetters.GET_INSURANCE_PROVIDERS]);
    const sendSubmissionBtnLoading = ref(false);
    const loadingProviders = ref(true);
    const productDropdownValue = ref("");
    const providerDropdownValue = ref("");
    const {
      SUBMIT_INSURANCE_REQUEST,
      GET_INSURANCE_SUBMISSIONS_HISTORY,
      LOAD_INSURANCE_PROVIDERS
    } = useApplicationStoreActions([ApplicationsActions.SUBMIT_INSURANCE_REQUEST, ApplicationsActions.GET_INSURANCE_SUBMISSIONS_HISTORY, ApplicationsActions.LOAD_INSURANCE_PROVIDERS]);
    const {
      coApplicantTypeOptions
    } = APPLICATION_FIELD_OPTIONS();
    const providerNameOptions = computed(() => (_GET_INSURANCE_PROVID => {
      const raw = (_GET_INSURANCE_PROVID = GET_INSURANCE_PROVIDERS.value) != null ? _GET_INSURANCE_PROVID : [];
      const providersArray = Array.isArray(raw) ? raw : (raw == null ? void 0 : raw.providers) || [];
      return _mapInstanceProperty(providersArray).call(providersArray, provider => ({
        label: provider.providerName || "",
        value: provider.providerId || "",
        products: provider.providerProducts || []
      }));
    })());
    const selectProductName = productName => {
      productDropdownValue.value = productName.value;
    };
    const selectProviderName = providerName => {
      providerDropdownValue.value = providerName.value;
    };
    const errorMsg = ref([]);
    const selectedProvider = computed(() => {
      var _context, _GET_INSURANCE_PROVID2;
      const val = providerDropdownValue.value;
      const fromOptions = _findInstanceProperty(_context = providerNameOptions.value).call(_context, p => p.value === val);
      if (fromOptions) return fromOptions;
      const raw = (_GET_INSURANCE_PROVID2 = GET_INSURANCE_PROVIDERS.value) != null ? _GET_INSURANCE_PROVID2 : [];
      const providersArray = Array.isArray(raw) ? raw : (raw == null ? void 0 : raw.providers) || (raw == null ? void 0 : raw.data) || (raw == null ? void 0 : raw.items) || [];
      const found = _findInstanceProperty(providersArray).call(providersArray, prov => [prov.providerId].some(pv => pv === val));
      if (found) return {
        label: found.providerName || "",
        value: found.providerId || "",
        products: found.providerProducts || []
      };
      return undefined;
    });
    const productNameOptions = computed(() => {
      var _selectedProvider$val;
      const products = ((_selectedProvider$val = selectedProvider.value) == null ? void 0 : _selectedProvider$val.products) || [];
      return _mapInstanceProperty(products).call(products, product => _objectSpread({
        label: t(`provider-product-names.${product.productName}`) || "",
        value: product.productId.toString() || ""
      }, product));
    });
    watch(providerNameOptions, options => {
      if (Array.isArray(options) && options.length === 1) {
        providerDropdownValue.value = options[0].value;
      }
    }, {
      immediate: true,
      deep: true
    });
    watch(productNameOptions, options => {
      if (Array.isArray(options) && options.length === 1) {
        productDropdownValue.value = options[0].value;
      }
    }, {
      immediate: true,
      deep: true
    });
    const coApplicants = computed(() => {
      var _CURRENT_APPLICATION$, _CURRENT_APPLICATION$2;
      return (_CURRENT_APPLICATION$ = CURRENT_APPLICATION.value) == null ? void 0 : (_CURRENT_APPLICATION$2 = _CURRENT_APPLICATION$["co-applicants"]) == null ? void 0 : _filterInstanceProperty(_CURRENT_APPLICATION$2).call(_CURRENT_APPLICATION$2, coApp => {
        var _coApp$personalDetai;
        return ((_coApp$personalDetai = coApp["personal-details"]) == null ? void 0 : _coApp$personalDetai["co-applicant-type"]) !== "guarantor";
      });
    });
    const mapApplicantType = applicantType => {
      var _coApplicantTypeOptio;
      return (_coApplicantTypeOptio = _findInstanceProperty(coApplicantTypeOptions).call(coApplicantTypeOptions, option => option.value === applicantType)) == null ? void 0 : _coApplicantTypeOptio.label;
    };
    const getFullName = ({
      "first-name": firstName,
      "last-name": lastName
    }) => {
      var _context2;
      const names = _filterInstanceProperty(_context2 = [firstName, lastName]).call(_context2, Boolean);
      return names.length > 0 ? names.join(" ") : "";
    };
    const allApplicants = computed(() => {
      var _CURRENT_APPLICATION$3, _CURRENT_APPLICATION$4, _context3, _coApplicants$value, _context4;
      const mainApplicantDetails = (_CURRENT_APPLICATION$3 = CURRENT_APPLICATION.value) == null ? void 0 : (_CURRENT_APPLICATION$4 = _CURRENT_APPLICATION$3["main-applicant"]) == null ? void 0 : _CURRENT_APPLICATION$4["personal-details"];
      const main = {
        fullName: mainApplicantDetails ? getFullName(mainApplicantDetails) : "",
        applicantType: t("application-form.primary-applicant"),
        username: clientUsername.value
      };
      const coApps = _mapInstanceProperty(_context3 = (_coApplicants$value = coApplicants.value) != null ? _coApplicants$value : []).call(_context3, coApp => {
        var _coApp$personalDetai2, _coApp$personalDetai3, _coApp$personalDetai4;
        return {
          fullName: getFullName((_coApp$personalDetai2 = coApp["personal-details"]) != null ? _coApp$personalDetai2 : {}),
          applicantType: ((_coApp$personalDetai3 = coApp["personal-details"]) == null ? void 0 : _coApp$personalDetai3["co-applicant-type"]) === "applicant" ? t("application-form.co-applicant") : mapApplicantType((_coApp$personalDetai4 = coApp["personal-details"]) == null ? void 0 : _coApp$personalDetai4["co-applicant-type"]),
          username: coApp.id
        };
      });
      return _filterInstanceProperty(_context4 = [main, ...coApps]).call(_context4, applicant => applicant.fullName !== "" || applicant.applicantType);
    });
    watch(allApplicants, apps => {
      if (!apps) return;
      applicantsChecked.value = _mapInstanceProperty(apps).call(apps, (_, idx) => ({
        index: idx,
        isChecked: idx === 0
      }));
    }, {
      immediate: true
    });
    const handleSubmitRequest = async () => {
      var _context5, _context6, _productNameOptions$v, _context7, _providerNameOptions$, _context8;
      const coApplicants = _mapInstanceProperty(_context5 = _filterInstanceProperty(_context6 = allApplicants.value).call(_context6, (_, index) => index !== 0 && applicantsChecked.value[index].isChecked)).call(_context5, applicant => applicant.username);
      const productId = (_productNameOptions$v = _findInstanceProperty(_context7 = productNameOptions.value).call(_context7, prod => prod.value === productDropdownValue.value)) == null ? void 0 : _productNameOptions$v.value;
      const providerId = (_providerNameOptions$ = _findInstanceProperty(_context8 = providerNameOptions.value).call(_context8, prod => prod.value === providerDropdownValue.value)) == null ? void 0 : _providerNameOptions$.value;
      sendSubmissionBtnLoading.value = true;
      errorMsg.value = [];
      try {
        const {
          res
        } = await SUBMIT_INSURANCE_REQUEST({
          clientUsername: clientUsername.value,
          data: {
            providerId,
            productId,
            coApplicants
          }
        });
        sendSubmissionBtnLoading.value = false;
        loadingSubmissions.value = true;
        if (res && res.status === 400) {
          errorMsg.value = res.responseJSON.insuranceValidationErrors;
        } else {
          showToast("success", tc("application-form.submitRequestSuccess"));
        }
      } finally {
        cleanData();
        await GET_INSURANCE_SUBMISSIONS_HISTORY(clientUsername.value);
        loadingSubmissions.value = false;
      }
    };
    const tableData = computed(() => {
      var _INSURANCE_SUBMISSION;
      return INSURANCE_SUBMISSIONS_HISTORY.value && INSURANCE_SUBMISSIONS_HISTORY.value.length !== 0 ? (_INSURANCE_SUBMISSION = INSURANCE_SUBMISSIONS_HISTORY.value) == null ? void 0 : _mapInstanceProperty(_INSURANCE_SUBMISSION).call(_INSURANCE_SUBMISSION, insuranceData => {
        var _allApplicants$value$, _context9, _insuranceData$coAppl;
        const applicants = [];
        const mainApplicant = (_allApplicants$value$ = _findInstanceProperty(_context9 = allApplicants.value).call(_context9, applicant => applicant.username === insuranceData.clientUsername)) == null ? void 0 : _allApplicants$value$.fullName;
        if (mainApplicant) {
          applicants.push(mainApplicant + "\n");
        }
        (_insuranceData$coAppl = insuranceData.coApplicants) == null ? void 0 : _insuranceData$coAppl.forEach(coApp => applicants.push(coApp + "\n"));
        return {
          statusDateTime: insuranceData.updatedAt,
          name: applicants,
          provider: insuranceData.insuranceProviderName,
          product: t(`provider-product-names.${insuranceData.insuranceProductName}`),
          submissionStatus: insuranceData.status === "failed" ? t("filogix.dealStatuses.failed") : t("application.status.submitted")
        };
      }) : [];
    });
    const cleanData = () => {
      consentChecked.value = false;
      applicantsChecked.value.forEach((applicant, index) => {
        if (index !== 0) applicant.isChecked = false;
      });
      sendSubmissionBtnLoading.value = false;
      if (Array.isArray(providerNameOptions.value) && providerNameOptions.value.length > 1) providerDropdownValue.value = "";
      if (Array.isArray(productNameOptions.value) && productNameOptions.value.length > 1) productDropdownValue.value = "";
    };
    const tableOptions = {
      filterable: false,
      perPage: 999999,
      sortable: [],
      skin: "table table-hover",
      texts: {
        noResults: "no history"
      },
      columns: ["statusDateTime", "name", "provider", "product", "submissionStatus"],
      headings: {
        statusDateTime: t("application.services.statusDateTime"),
        name: t("application.services.name"),
        confirmationNumber: t("application.services.confirmationNumber"),
        provider: t("application.services.provider"),
        product: t("application.services.product"),
        submissionStatus: t("application.services.submissionStatus")
      }
    };
    const getSubmissions = () => {};
    onMounted(async () => {
      if (!hasReferralPartners) return;
      await LOAD_INSURANCE_PROVIDERS();
      loadingSubmissions.value = true;
      loadingProviders.value = false;
      try {
        await GET_INSURANCE_SUBMISSIONS_HISTORY(clientUsername.value);
      } finally {
        loadingSubmissions.value = false;
      }
    });
    return {
      CURRENT_APPLICATION_HAS_REQUESTED_MORTGAGES,
      hasReferralPartners,
      formatDateHour,
      providerNameOptions,
      productNameOptions,
      tableOptions,
      allApplicants,
      applicantsChecked,
      consentChecked,
      handleSubmitRequest,
      getSubmissions,
      selectProviderName,
      selectProductName,
      productDropdownValue,
      tableData,
      loadingSubmissions,
      providerDropdownValue,
      sendSubmissionBtnLoading,
      errorMsg,
      mapApplicantType,
      loadingProviders
    };
  }
});